module.exports = __webpack_public_path__ + "assets/cynergy-logo-no-text-white.10189172.svg";